<template>
  <SectionSplit
    class="SigBondReport2025 reverse"
    :formats="[]"
    src="../../assets/solutions/investors.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />

    <p
      v-for="(link, index) in $t('links')"
      :key="index"
      v-html="link" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.SigBondReport2025 {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Sun Investment Group, UAB financial report set for the year 2025",
    "paragraphs": [
      "The financial statements of Sun Investment Group, UAB, the independent auditor's opinion, the consolidated annual report, and the consolidated financial statements for the year ending 31 December 2025 are provided."
    ],
    "links": [
      "<a href=\"https://sig-web-uploads.s3.eu-central-1.amazonaws.com/SIG_260731_SHD_02_Annex_No_1_1_375ecb24f5.pdf\" target=\"_blank\">INDEPENDENT AUDITOR’S REPORT AND FINANCIAL STATEMENTS</a>",
      "<a href=\"https://sig-web-uploads.s3.eu-central-1.amazonaws.com/SIG_260731_SHD_02_Annex_No_2_2_22b1287c8f.pdf\" target=\"_blank\">INDEPENDENT AUDITOR’S REPORT, CONSOLIDATED MANAGEMENT REPORT AND CONSOLIDATED FINANCIAL STATEMENTS for the year ended on 31 December 2025</a>"
    ]
  },
  "lt": {
    "title": "Sun Investment Group, UAB finansinių ataskaitų rinkinys už 2025 metus",
    "paragraphs": [
      "Pateikiamos Sun Investment Group, UAB Finansinės ataskaitos, nepriklausomo auditoriaus išvada, konsoliduotasis metinis pranešimas, konsoliduotosios finansinės ataskaitos už metus, pasibaigusius 2025 m. gruodžio 31 d."
    ],
    "links": [
      "<a href=\"https://sig-web-uploads.s3.eu-central-1.amazonaws.com/SIG_260731_SHD_02_Annex_No_1_2_b2b241f3c8.pdf\" target=\"_blank\">NEPRIKLAUSOMO AUDITORIAUS IŠVADA IR FINANSINĖ ATSKAITOMYBĖ</a>",
      "<a href=\"https://sig-web-uploads.s3.eu-central-1.amazonaws.com/SIG_260731_SHD_02_Annex_No_2_1_a035e2c3fa.pdf\" target=\"_blank\">NEPRIKLAUSOMO AUDITORIAUS IŠVADA, KONSOLIDUOTA VADOVYBĖS ATASKAITA IR KONSOLIDUOTA FINANSINĖ ATSKAITOMYBĖ už metus, pasibaigusius 2025 m. gruodžio 31 d.</a>"
    ]
  }
}
</i18n>
